
<style lang="scss" scoped>
.vslist-detail {
  min-height: 20px;
  padding: 16px;
  margin-bottom: 20px;
  background-color: #f3f7f9;
  border: 1px solid #e4eaec;
  border-radius: 3px;
  width: 80%;
}
</style>

<template>
    <div class="lookitem">
        <Breadcrumb class="tablelist-header">
            <BreadcrumbItem>{{$t('erp.virtualstore.editwareallocratio',{defaultValue:'编辑虚拟仓分配比例'})}}</BreadcrumbItem>
        </Breadcrumb>
        <Alert class="padding-10">
            <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
		</Alert>
        <Row class="bg-fff shadow padding-bottom-20">
            <Col span='24'>
            <header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
            </Col>
            <Col span='12'>
            <span class="item-label">{{$t('global.common.name',{defaultValue:'名称'})}}：</span>
            <a class="item-content" @click="seeDetail">{{formData.name}}</a>
            </Col>
            <Col span='12'>
            <span class="item-label">{{$t('global.common.project',{defaultValue:'项目'})}}：</span>
            <span class="item-content">{{formData.lineId|transferText('name',products)}}</span>
            </Col>
            <Col span='12'>
            <span class="item-label">ERPSKU：</span>
            <span class="item-content">{{formData.erpSku}}</span>
            <!-- <Button @click="seeDetail">查看详细信息</Button> -->
            </Col>
            <Col span='24'>
            <Form :label-width="100" ref="form">
                <section v-for="(item,index) in svRules" class="clearfix" :key="index">
                    <header class="item-label">{{item.stockGroupName}}</header>
                    <section class="item-content vslist-detail">
                        <div class="clearfix padding-top-5" v-for="data in item.stockVirtualGroupRuleItemEntity" :key="data.id">
                            <span class="width-80per pull-left">{{data.warehouseTitle}}({{data.warehouseCode}})</span>
                            <InputNumber class="pull-left" v-model="data.assignPercent"/>
                            %
                        </div>
                    </section> 
                </section>
            </Form>
            </Col>
            <Col span="24" class="text-center padding-10">
            <!-- <Button type="primary" class="width-15per" @click="routeBack">上一步</Button> -->
            <Button type="primary" class="width-15per" @click="submit">{{$t('erp.distribution.confirm_submit',{defaultValue:'提交'})}}</Button>
            <Button class="width-15per" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
            </Col>
        </Row>
        <!-- 查看信息按钮 -->
        <Modal
        class="hidefooter"
        v-model='operate.show'
        :mask-closable='false'
        v-bind="operate">
            <component :is="operate.component" @on-close="operate={}" v-bind="operate" v-if="operate.show"/>
            <footer slot="footer" v-show="false"></footer>
        </Modal>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import {
    HttpVsDetail, HttpSaveVs, HttpEditorAllot
} from '@/service/boss/allot';
import compDetail from './detail';
export default {
    components: {
        compDetail
    },
    data() {
        return {
            loading: false,
            id: this.$route.params.id,
            // type: this.$route.params.type,
            // sourceData: this.$route.query.json,
            svRules: [],
            sourceData:'',
            formData: {
                name: "",
                lineId: "",
                erpSku: "",
                description: "",
                productId: "",
                status: "",
            },
            operate: {
                id: null,
                title: "",
                show: false,
                component: null
            },

        }
    },
    created() {
        this.getDetail();
    },

    filters: {
        transferText(val, textKey, list = [], key = "id") {
            let text = "";
            list.forEach(item => {
                if (item[key] === val) {
                    text = item[textKey]
                }
            });
            return text;
        }
    },
    computed: {
        ...mapState('boss',['products', 'accounts']),
        ...mapGetters('boss',['warehouses']),
        accountsTarget() {
            return this.accounts.map((item) => {
                return {
                    label: `${item.title}(${item.flag})`,
                    key: item.id,
                }
            })
        },
    },
    methods: {
        async getDetail() {
            this.loading = true;
            HttpVsDetail({
                id: this.id
            }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.errorMessage(err.message);
                this.loading = false;
            });
        },
        handleResponse(data = {}){
            let { name, lineId, erpSku, description, status } = data;
            this.formData = { name, lineId, erpSku, description, status };
            // console.log(data)
            this.sourceData = data;
            this.svRules = data.stockVirtualGroupRules
        },
        handleRequest(data){
            // let dataNumber=[];
            // dataNumber.groupId = this.id;
            // data.list
            let dataAllot = [];
            dataAllot =  data.stockVirtualGroupRules.map((items,index) => {
                let id = items.id;
                let orgWarehouseIds = items.stockVirtualGroupRuleItemEntity.map((item) => {
                    // console.log(item)
                    return {
                        orgWarehouseId: item.orgWarehouseId,
                        assignPercent: item.assignPercent
                    }
                })
                return {
                    id: id,
                    orgWarehouseIds: orgWarehouseIds
                }
            })
            // dataNumber.list = aaa;
            return dataAllot
            // console.log(aaa)
        },
        // 提交
        submit(){
            let sourceData = this.sourceData;
            let dataAllot = this.handleRequest(sourceData)
            // console.log(dataAllot)
            // console.log(bbb)
            HttpEditorAllot({
                groupId: this.id,
                list: dataAllot
            }).then( res => {
                this.$Message.success(res.message);
                this.loading = false;
                this.$router.push({ name: "vstorelist" })
            },err => {
                if(err.code==500){
                    this.$Message.error(this.$t('erp.virtualstore.nullnumber',{defaultValue:'数值不能为空'}));
                    this.loading = false;
                }else{
                    this.errorMessage(err.message);
                    this.loading = false;
                }
            })
        },
        // 取消
        cancel() {
            this.$router.push({ name: "vstorelist" })
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
        // 查看页面
        seeDetail(){
            this.operate = {
                id:this.id,
                title: this.$t('global.common.operation_see',{defaultValue:'查看'}),
                component: 'compDetail',
                show: true,
                width: 760,

            }
        },
    }
}
</script>

